/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamMatchResult
 */
export interface TeamMatchResult {
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    opponentTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    opponentTeamName?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamMatchResult
     */
    teamScore?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamMatchResult
     */
    opponentScore?: number;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    result?: TeamMatchResultResult;
    /**
     * 
     * @type {Date}
     * @memberof TeamMatchResult
     */
    matchTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    stageName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMatchResult
     */
    status?: TeamMatchResultStatus;
}

/**
* @export
* @enum {string}
*/
export enum TeamMatchResultResult {
    Win = 'WIN',
    Draw = 'DRAW',
    Loss = 'LOSS'
}
/**
* @export
* @enum {string}
*/
export enum TeamMatchResultStatus {
    Scheduled = 'SCHEDULED',
    InProgress = 'IN_PROGRESS',
    Finished = 'FINISHED'
}


/**
 * Check if a given object implements the TeamMatchResult interface.
 */
export function instanceOfTeamMatchResult(value: object): value is TeamMatchResult {
    return true;
}

export function TeamMatchResultFromJSON(json: any): TeamMatchResult {
    return TeamMatchResultFromJSONTyped(json, false);
}

export function TeamMatchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamMatchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'opponentTeamId': json['opponentTeamId'] == null ? undefined : json['opponentTeamId'],
        'opponentTeamName': json['opponentTeamName'] == null ? undefined : json['opponentTeamName'],
        'teamScore': json['teamScore'] == null ? undefined : json['teamScore'],
        'opponentScore': json['opponentScore'] == null ? undefined : json['opponentScore'],
        'result': json['result'] == null ? undefined : json['result'],
        'matchTime': json['matchTime'] == null ? undefined : (new Date(json['matchTime'])),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'stageName': json['stageName'] == null ? undefined : json['stageName'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function TeamMatchResultToJSON(json: any): TeamMatchResult {
    return TeamMatchResultToJSONTyped(json, false);
}

export function TeamMatchResultToJSONTyped(value?: TeamMatchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'opponentTeamId': value['opponentTeamId'],
        'opponentTeamName': value['opponentTeamName'],
        'teamScore': value['teamScore'],
        'opponentScore': value['opponentScore'],
        'result': value['result'],
        'matchTime': value['matchTime'] == null ? value['matchTime'] : value['matchTime'].toISOString(),
        'groupName': value['groupName'],
        'stageName': value['stageName'],
        'status': value['status'],
    };
}

